<template>
  <div class="user-container">
    <div class="table-field">
      <el-row>
        <el-button class type="primary" @click="dialogFormVisible = true">新增</el-button>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      :row-style="{height:'30px'}"
      :cell-style="{padding:'5px 0'}"
      style="width: 100%"
      height="580px"
      :border="true"
      :header-cell-style="{background: '#f2f2f2'}"
    >
      <el-table-column prop="name" label="角色名称"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === `2`" type="success">已启用</el-tag>
          <el-tag v-if="scope.row.status === `1`" type="warning">未启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="250" label="操作">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-caret-right"
            v-if="scope.row.status   !== `2` "
            @click="handleActive(scope.row.id)"
          >启用</el-button>
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="handleClickRole(scope.row.id)"
            size="mini"
          >权限</el-button>
          <el-button
            type="danger"
            icon="el-icon-edit"
            v-if="scope.row.status === `2`"
            size="mini"
            @click="handleForbid(scope.row.id)"
          >禁用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增角色" :width="`350px`" :visible.sync="dialogFormVisible">
      <el-form :model="roleDTO">
        <el-form-item label="角色名称">
          <el-input v-model="roleDTO.roleName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddRole">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="角色权限分配" :visible.sync="dialogRoleVisible">
      <el-transfer
        style="text-align: left; display: inline-block"
        v-model="roleMenuDTO.menuList"
        :data="menuList"
        :titles="['未拥有', '已拥有']"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRoleVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddRoleMenu">授 权</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  addRole,
  adminMenuList,
  addRoleMenu,
  getRoleMenuList,
  activeRole,
  forbidRole
} from "@/axios/api";
export default {
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      dialogRoleVisible: false,
      roleDTO: {
        roleName: ""
      },
      menuList: [],
      roleMenuDTO: {
        roleId: "",
        menuList: []
      }
    };
  },
  methods: {
    handleForbid(id){
      forbidRole({ id: id}).then(res => {
        if(res.status === 200){
          this.$message.success("禁用成功");
          this.getRoleList();
        }
      })
    },
    handleActive(id){
      activeRole({ id: id}).then(res => {
        if(res.status === 200){
          this.$message.success("启用成功");
          this.getRoleList();
        }
      })
    },
    handleAddRoleMenu() {
      addRoleMenu(this.roleMenuDTO).then(res => {
        if (res.status == 200) {
          this.$message.success("授权成功");
        }
      });
    },
    handleClickRole(id) {
      this.dialogRoleVisible = true;
      this.roleMenuDTO.roleId = id;
      this.userGetRoleMenuList(id);
    },
    handleAddRole() {
      this.dialogFormVisible = false;
      addRole(this.roleDTO).then(res => {
        if (res.status === 200) {
          this.$message.success("保存成功");
          this.getRoleList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getRoleList() {
      roleList().then(res => {
        this.tableData = res.data;
      });
    },
    getAdminMenuList() {
      adminMenuList().then(res => {
        res.data.forEach((el, index) => {
          this.menuList.push({
            key: el.id,
            label: el.name
          });
        });
      });
    },
    userGetRoleMenuList(id) {
      getRoleMenuList({ roleId: id }).then(res => {
        if (res.status === 200) this.roleMenuDTO.menuList = res.data;
      });
    }
  },
  mounted() {
    this.getRoleList();
    this.getAdminMenuList();
  }
};
</script>

<style scoped>
.table-field .el-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-field {
  width: 100%;
  height: 60px;
  border: 1px solid #ebebeb;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.user-container {
  width: 100%;
  height: auto;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/role/Role.vue